import { useSuspenseQuery } from '@tanstack/react-query';
import { goodsService } from 'shared/src/api';
import { queryKey } from '../constant/queryKey';
import { useGoodsSno } from '../hooks/useGoodsSno';

export const useGoodsReviewsAvailableInfo = () => {
  const sno = useGoodsSno();
  return useSuspenseQuery({
    queryKey: queryKey.goodsReviewsAvailableInfo(sno),
    queryFn: () => goodsService.getGoodsReviewsAvailableInfo(sno),
  });
};